import type { FC } from "react"

import { ArticleCoverArt } from "@productlane/ui/src/components/article-cover-art"
import { ArticleDuotoneIcon } from "@productlane/ui/src/components/article-duotone-icon"

// Same art the portal shows for an article without a cover.
export const DefaultArticleCover: FC<{
	icon: string | null | undefined
	logoUrl: string | null | undefined
	workspaceName: string | null | undefined
	accent: string | null | undefined
}> = ({ icon, logoUrl, workspaceName, accent }) => (
	<ArticleCoverArt
		accent={accent || "#18BDCC"}
		logoUrl={logoUrl}
		workspaceName={workspaceName}
		icon={<ArticleDuotoneIcon icon={icon} />}
	/>
)
